<div
  class="tableContainerStyle"
>
  <div
    class="tableWrapper"
  >
    <table
      mat-table
      [dataSource]="getRatingsList()"
      class="wholeTableStyle"
    >
      <ng-container
        *ngFor="let columnName of displayedColumnsNames; index as i"
        matColumnDef="{{columnName}}"
      >
        <th
          mat-header-cell
          *matHeaderCellDef
          class="tableHeaderCell"
        >
          <div
            class="tableHeaderCellContent"
          >
            {{columnName}}
          </div>
        </th>
        <td
          [id]="i"
          mat-cell
          *matCellDef="let rating"
          class="tableRowCell"
        >
          <div
            class="tableRowCellContent"
          >
            {{transformData(rating[headerToKey()[columnName]])}}
          </div>
        </td>
      </ng-container>
      <tr
        mat-header-row
        class="tableStickyHeader"
        *matHeaderRowDef="displayedColumnsNames"
      ></tr>
      <tr
        mat-row
        class="tableRow"
        *matRowDef="let row; columns: displayedColumnsNames;"
        (click)="clickHandler($event, row)"
      ></tr>
    </table>
  </div>
</div>
